import { Fragment, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Remounts everything below it when the language changes.
 *
 * Translated *strings* need no help — `useTranslation` re-renders its own
 * subscribers. Formatted *values* do: `formatDate`, `formatCents` and the rest
 * read `i18n.language` internally, so the language is a dependency React
 * Compiler cannot see. It memoizes `formatDate(campaign.createdAt)` on
 * `createdAt` alone, and switching to Russian leaves «Aug 8, 2026» on screen
 * beside a fully translated page.
 *
 * Threading the locale through all twenty call sites would fix today's ones and
 * leave the trap armed for the next formatter someone writes. A remount fixes
 * the class of bug instead. It costs the page's local state — an open dialog,
 * a scroll position — which is a fair price for an action a user takes once.
 */
export function LocaleBoundary({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation()

  return <Fragment key={i18n.resolvedLanguage}>{children}</Fragment>
}
